import script from "./RotateLeftIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RotateLeftIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__